import { AxiosRequestConfig } from "axios";

export const postContactConfig: AxiosRequestConfig = {
  method: "post",
  url: "/contact",
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json",
  },
};
